<template>
    <div>

        <menu-bar/>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li class="active">INICIAL</li>
                </ol>

                <list-offlines v-if="user.level > 0" />
                <list-bloqueados v-if="user.level > 0"/>

            </div>
        </div>

    </div>
</template>
<script>
import { ListBloqueados, ListOfflines } from "../components/exports";
export default {
    components: {
        ListOfflines,
        ListBloqueados
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (!this.user) {
            this.$router.push("/login");
        }
    }
};
</script>
